module.exports = __webpack_public_path__ + "media/bg_bg_s1_Daria.95c02a92.wav";